import { render, staticRenderFns } from "./merchant_street.vue?vue&type=template&id=fce54d3c&scoped=true"
import script from "./merchant_street.vue?vue&type=script&lang=js"
export * from "./merchant_street.vue?vue&type=script&lang=js"
import style0 from "./merchant_street.vue?vue&type=style&index=0&id=fce54d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce54d3c",
  null
  
)

export default component.exports